// extracted by mini-css-extract-plugin
export default {"header":"legal_header__nMBoz","tagline-container":"legal_tagline-container__XaGHL","tagline-title":"legal_tagline-title__bPomH","tagline-subtitle":"legal_tagline-subtitle__Nj4Yq"};